import React from "react";
import withAuthentication from "./Session/withAuthentication";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getTags, getTagsWithConfirmed } from "../state/tags/selectors";
import { config } from "../state/course-config";
import { injectCourseProgress } from "moocfi-quizzes";
import _ from "lodash";

class SectionCompletion extends React.Component {
  static contextTypes = {
    loggedIn: PropTypes.bool
  };

  render() {
    const {
      tags,
      tagsWithConfirmed,
      part,
      section,
      data,
      courseProgressData
    } = this.props;
    const { loggedIn } = this.context;

    const tag = (part, section) =>
      `${config.COURSE_SHORT_ID}_${part}_${section}`;

    const getBySection = (arr, part, section) =>
      _.get(arr, tag(part, section), []);
    const quizzesPerTag = getBySection(tags, part, section);
    const confirmedPerTag = getBySection(tagsWithConfirmed, part, section);

    let completed = 0;


    if (courseProgressData) {
      const sec = courseProgressData.exercise_completions_by_section.find(
        s => s.part === part && s.section === section
      );
      sec && (completed = Number.parseInt(sec.exercises_completed));
    }

    const exercisesByPartSection = {
      1: {
        1: 1,
        2: 2,
        3: 1
      },
      2: {
        1: 2,
        2: 0,
        3: 1
      },
      3: {
        1: 2,
        2: 2,
        3: 2
      },
      4: {
        1: 0,
        2: 2,
        3: 4
      },
      5: {
        1: 1,
        2: 2,
        3: 0
      },
      6: {
        1: 1,
        2: 1,
        3: 1
      }
    };

    const total = exercisesByPartSection[part][section];

    if (total === 0) {
      return "---";
    }

    return (
      <span
        style={{ color: completed === total && total > 0 ? "#32C2A2" : "" }}
      >
        {completed || 0}/{total}
      </span>
    );
  }
}

const mapStateToProps = state => ({
  tags: getTags(state),
  tagsWithConfirmed: getTagsWithConfirmed(state)
});

export default connect(mapStateToProps)(
  withAuthentication(injectCourseProgress(SectionCompletion))
);
